/** @file pastePose: writes the copied pose at a frame of the playhead clip (clip.copyPose). */
import type { EditorStore } from '../../state/editorTypes';
import { currentClip } from './currentClip';
import { mirrorGuard } from './mirrorGuard';
import type { PoseClipboard } from './poseClipboard';

/** `clip.copyPose { clip, from, to, fromClip }` from the clipboard; a toast when it is empty or the frame is mirrored. */
export function pastePose(store: EditorStore, clipboard: PoseClipboard, frame: number): void {
  const s = store.getState();
  const cur = currentClip(s);
  const from = clipboard.current;
  if (cur === null || from === null) { s.notify('info', 'Copy a pose first'); return; }
  if (mirrorGuard(cur.clip, frame, s.notify)) return;
  void s.dispatch([{ name: 'clip.copyPose', input: { clip: cur.name, from: from.frame, to: frame, fromClip: from.clip } }], `paste pose @${frame}`);
}
